export const ROUTE_VERIFY_EMAIL = '/auth/verify-email';
export const ROUTE_LOGIN = '/auth/login';
